<template>
  <div>
    <v-list-item class="pl-0">
      <v-list-item-avatar>
        <v-icon large>{{ icon }}</v-icon>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title :class="specificTitleClasses" class="cardTitle">
          {{ title }}
        </v-list-item-title>
        <div v-if="Array.isArray(subtitle)">
          <v-list-item-subtitle
            v-for="(item, index) in subtitle"
            :class="specificSubtitleClasses"
            :key="index"
          >
            {{ item }}
          </v-list-item-subtitle>
        </div>
        <v-list-item-subtitle v-else :class="specificSubtitleClasses">
          {{ subtitle }}
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
    <div class="d-flex" v-if="status && status.color && status.icon">
      <v-icon
        class="techStatus mr-2 pa-1"
        color="#fff"
        small
        :style="`background-color: ${status.color};`"
      >
        {{ status.icon }}
      </v-icon>
      <v-list-item-subtitle>
        {{ status.label }}
      </v-list-item-subtitle>
    </div>
    <v-list-item-subtitle :class="specificAlertClasses">
      {{ alert }}
    </v-list-item-subtitle>
    <v-list-item-action-text v-if="chip && chip.title">
      <v-tooltip bottom max-width="50%">
        <template v-slot:activator="{ on }">
          <div v-on="on">
            <v-chip small text-color="opposite" color="warning">
              Absence&nbsp;{{ chip.title }}
            </v-chip>
          </div>
        </template>
        <span>{{ chip.subtitle }}</span>
      </v-tooltip>
    </v-list-item-action-text>
  </div>
</template>

<script>
import { generateMessage } from '@/utils/i18n';

export default {
  name: 'CustomLightCard',
  props: {
    alert: { type: String, required: false },
    icon: { type: String, required: true },
    title: { type: String, required: true },
    subtitle: { type: [String, Array], required: true },
    specificAlertClasses: { type: String, required: false },
    specificTitleClasses: { type: String, required: false },
    specificSubtitleClasses: { type: String, required: false },
    status: { type: Object, required: false },
    chip: { type: Object, required: false },
  },
  methods: {
    generateMessage,
  },
};
</script>

<style scoped>
.cardTitle {
  font-size: 0.9rem;
}
.techStatus {
  width: max-content;
  border-radius: 50px;
}
</style>
